module.exports = __webpack_public_path__ + "img/Sante.bafee69f.svg";